// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1KTum","inputWrap":"CustomTip_inputWrap__IBL9l"};